import service from "../services/settings.service"; // Asegúrate de que el servicio esté configurado correctamente

export const settings = {
    namespaced: true,
    state: {
    },
    getters: {
    },
    actions: {
        async get(context,data) {  
            try {
                const response = await service.get(data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async save(context,data) {  
            try {
                const response = await service.updateData(data);
                return response;
            } catch (error) {
                console.error("Error fetching get data:", error);
                throw error.response;
            }
        },
        async generateShopifyToken() {
            try {
                const response = await service.generateShopifyToken();
                return response;
            } catch (error) {
                console.error("Error generating Shopify token:", error);
                throw error.response;
            }
        },
        async generateKubappToken() {
            try {
                const response = await service.generateKubappToken();
                return response;
            } catch (error) {
                console.error("Error generating kubApp token:", error);
                throw error.response;
            }
        },
    },
    mutations: {
    },
};
